module.exports = __webpack_public_path__ + "img/es_mi_videostill4.088f881a.jpg";